export default __webpack_public_path__ + "static/media/bubble-chat.3ac5fe7e.svg";